import defaultTheme from 'tailwindcss/defaultTheme';

export const colors = {
  primary: '#D7622B',
  secondary: '#1F4E99',
  tertiary: '#53AFE3',
  gray: {
    900: '#2c3538',
    800: '#575756',
    700: '#898989',
    600: '#9CA3AF',
    300: '#E5E5E5',
    lighter: '#f7f7f7',
    'lighter-active': 'hsla(0, 0%, 92%, 1)',
    light: '#d4d1d1',
    medium: '#a8a0a0',
    dark: '#998e8e',
    darker: '#504747',
    darker2: '#111827',
  },
  slate: {
    700: '#6F7684',
  },
  yellow: {
    50: '#fefce8',
    100: '#fef9c3',
    200: '#fef08a',
    300: '#fde047',
    400: '#facc15',
    500: '#eab308',
    600: '#ca8a04',
    700: '#a16207',
    800: '#854d0e',
    900: '#713f12',
  },
  orange: {
    100: '#FFEDD5',
    300: '#F7C2B1',
    400: '#FB923C',
    500: '#e9580c',
    ...(defaultTheme.colors as any).orange,
  },
  red: {
    50: '#fef2f2',
    100: '#fee2e2',
    200: '#fecaca',
    300: '#fca5a5',
    400: '#f87171',
    500: '#ff4d4f',
    600: '#dc2626',
    700: '#b91c1c',
    800: '#991b1b',
    900: '#7f1d1d',
  },
  blue: {
    50: '#eff6ff',
    100: '#F2FBFE',
    200: '#b8ebff',
    300: '#17B2E8',
    400: '#18b2e8',
    500: '#0063db',
    600: '#2563eb',
    700: '#004f9e',
    800: '#17245f',
    900: '#18245F',
    ...(defaultTheme.colors as any).blue,
  },
  green: {
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    300: '#86efac',
    400: '#4ADE80',
    500: '#228B5E',
    600: '#16a34a',
    700: '#15803d',
    800: '#166534',
    900: '#14532d',
  },
  purple: {
    50: '#faf5ff',
    100: '#f3e8ff',
    200: '#e9d5ff',
    300: '#d8b4fe',
    400: '#c084fc',
    500: '#a855f7',
    600: '#9333ea',
    700: '#7e22ce',
    800: '#6b21a8',
    900: '#581c87',
  },
  // Semantic colors
  success: {
    light: '#4ADE80',
    main: '#228B5E',
    dark: '#16a34a',
  },
  error: {
    light: '#f87171',
    main: '#ff4d4f',
    dark: '#dc2626',
  },
  warning: {
    light: '#fef08a',
    main: '#facc15',
    dark: '#eab308',
  },
  info: {
    light: '#b8ebff',
    main: '#17B2E8',
    dark: '#0063db',
  },
};
